/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { debounce } from 'lodash';
import {
    createNewCommunityGpt,
    getCommunityName
} from "../../../../Services/Community/CommunityAPI/communityApi";
import { capitalizeWords } from "../../../../Utils/LetterCase";
import { toast } from "react-toastify";
import { encryptId } from "../../../../Utils/Crypto"
import { ThreeDot } from "react-loading-indicators";
import community_icon from "../../../../images/Oscar.svg";
import Chatbot from '../../../Chatbot/Chatbot';
import { useLoadScript, Autocomplete } from "@react-google-maps/api";
import { GOOGLE_PLACES_API_KEY } from "../../../../Utils/Constant";
import { Box } from '@mui/material';

const libraries = ["places"];

const CommunitySearch = ({ realtorCode }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [communityName, setCommunityName] = useState("");
    const [inputValue, setInputValue] = useState("");
    const [isSelected, setIsSelected] = useState(false)
    const [showDropDown, setShowDropDown] = useState(false);
    const [communityNameData, setCommunityNameData] = useState([])
    const [id, setId] = useState("")
    const [city, setCity] = useState("");
    const [locationId, setLocationId] = useState("")
    const [isGenerated, setIsGenerated] = useState(false);
    const [errors, setErrors] = useState({});
    const [state, setState] = useState("");
    const [zipCode, setZipCode] = useState("")
    const [mes, setMes] = useState("");
    const [isPressed, setIsPressed] = useState(false);
    const [chatbotActive, setChatbotActive] = useState(false);
    const [DefaultQuestion, setDefaultQuestion] = useState(false);
    const { loading } = useSelector((state) => state.createNewCommunityGpt);

    useEffect(() => {
        // Debounced function to fetch community data by communityName
        const fetchCommunityName = debounce(async () => {
            if (communityName.trim()) {
                dispatch(getCommunityName({ communityName: communityName })).then((res) => {
                    setCommunityNameData(res?.payload?.data)
                    if (res?.payload?.data && !isSelected) {
                        setShowDropDown(true)
                    } else {
                        setShowDropDown(false)
                    }
                })
            }
        }, 300);  // Delay of 300ms

        // Call the debounced function when the communityName changes
        fetchCommunityName();

        // Cleanup function to cancel the debounce if communityName changes or component unmounts
        return () => {
            fetchCommunityName.cancel();
        };
    }, [communityName, dispatch]);

    const handleSelect = (community) => {
        setIsSelected(true)
        setId(community?.id)
        setCommunityName(community?.community_name || "");
        setCity(community?.location?.city || "");
        setInputValue(community?.community_name || "")
        setLocationId(community?.location?.id)
        setIsGenerated(community?.is_generated);
        if (inputValue === communityName) setShowDropDown(false)
    };

    const highlightMatch = (suggestion, query) => {
        const startIndex = suggestion.toLowerCase().indexOf(query.toLowerCase());
        if (startIndex === -1) return suggestion;

        const endIndex = startIndex + query.length;
        return (
            <>
                {suggestion.slice(0, startIndex)}
                <span
                    style={{
                        // textDecoration: 'underline',
                        textDecorationColor: '#dd483b', // Underline color (Orange)
                        textDecorationThickness: '2px', // Thicker underline
                        textUnderlineOffset: '4px', // Space between the text and underline
                        transition: 'all 0.3s ease', // Smooth transition for hover
                        fontWeight: 'normal', // Reduce font weight for highlighted text
                    }}
                >
                    {suggestion.slice(startIndex, endIndex)}
                </span>
                {suggestion.slice(endIndex)}
            </>
        );
    };

    const validateForm = () => {
        const errors = {};
        if (!communityName) {
            errors.community_name = "Please enter a community name";
        }

        if (!city) {
            errors.city = "Please enter a city";
        }

        setErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleSubmit = async (e) => {
        // setMes("")
        // if (!inputValueAuto) setShowDropDown(false)
        if (validateForm()) {
            dispatch(
                createNewCommunityGpt({
                    community_id: id || null,
                    community_name: communityName.trim(),
                    community_city: city,
                    community_state: state,
                    community_zip_code: zipCode,
                    location_id: locationId || null,
                })
            )
                // .unwrap()
                .then((res) => {
                    if (res?.payload?.status === 404) {
                        setMes(
                            "Sorry, we were unable to create your community, please contact us for assistance."
                        );
                    }
                    if (res?.payload?.status === 201) {
                        toast.success("Community created successfully! You can now view the details.");
                        setLocationId("")
                        setCity("")
                        setState("")
                        setZipCode("")
                        setId("")
                        setTimeout(() => { navigate(`/tab/${encryptId(res?.payload?.data?.community_id)}/${realtorCode}`); }, 300)
                    }
                    if (res?.payload?.status === 200) {
                        setLocationId("")
                        setCity("")
                        setState("")
                        setId("")
                        setZipCode("")
                        setTimeout(() => { navigate(`/tab/${encryptId(res?.payload?.data?.community_id)}/${realtorCode}`); }, 300)
                    }
                    setInputValue(communityName.trim()); // Ensure the search term matches for filtering
                })
                .catch((error) => {
                    console.error(
                        "Error fetching community data:",
                        error.response || error
                    );
                });
        }
    }

    const { isLoaded } = useLoadScript({
        googleMapsApiKey: GOOGLE_PLACES_API_KEY, // Replace with your actual API key
        libraries,
    });

    const [autocomplete, setAutocomplete] = useState(null);
    const [inputValueAuto, setInputValueAuto] = useState("");

    const onLoad = (autocompleteInstance) => {
        setAutocomplete(autocompleteInstance);
    };

    const onPlaceChanged = () => {
        if (autocomplete) {
            const place = autocomplete.getPlace();

            setInputValueAuto(place.formatted_address || place.name);

            const addressComponents = place.address_components || [];
            const cityComponent = addressComponents.find(component =>
                component.types.includes("locality")
            );
            const stateComponent = addressComponents.find(component =>
                component.types.includes("administrative_area_level_1")
            );
            const zipCodeComponent = addressComponents.find(component =>
                component.types.includes("postal_code")
            );

            const city = cityComponent?.long_name || "";
            const state = stateComponent?.short_name || "";
            const zipCode = zipCodeComponent?.long_name || null;

            if (city) {
                setCity(city);
                setState(state);
                setZipCode(zipCode);
            }
        }
    };

    if (!isLoaded) {
        return (
            <div>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        minHeight: "100vh",
                        flexDirection: "column",
                        textAlign: "center",
                    }}
                >
                    <ThreeDot color="#dd483b" size="medium" text="" textColor="" />
                </Box>
            </div>
        );
    }

    return (
        <div>
            <div className="title-ai">AI-Powered Community Resources</div>
            <p className="m-0">
                Your gateway to community insights, rules, applications and nearby vendors - all in one place for a smoother homeownership experience.
            </p>
            <div className="find-assct">Find Your Association</div>
            <div className="find-your-association-block tab-group d-flex align-items-start">
                <div className="search-field-block">
                    <input
                        type="text"
                        name="q"
                        id="community"
                        value={communityName}
                        disabled={loading}
                        onChange={(e) => {
                            const value = e.target.value;
                            setCommunityName(value);
                            setInputValue(value);
                            setMes("");
                            setCity("")
                            setInputValueAuto("")
                            setIsSelected(false)
                        }}
                        placeholder="Search by name"
                        autoComplete="off"
                    />
                    <div className="search-icon-box">
                        <svg
                            width="17"
                            height="17"
                            viewBox="0 0 17 17"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M11.5625 12.0625L15.3125 15.8125"
                                stroke="#414141"
                                strokeOpacity="0.8"
                                strokeWidth="1.875"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M6.875 13.3125C10.1542 13.3125 12.8125 10.6542 12.8125 7.375C12.8125 4.09581 10.1542 1.4375 6.875 1.4375C3.59581 1.4375 0.9375 4.09581 0.9375 7.375C0.9375 10.6542 3.59581 13.3125 6.875 13.3125Z"
                                stroke="#414141"
                                strokeOpacity="0.8"
                                strokeWidth="1.875"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </div>
                    {
                        showDropDown && inputValue && Object.keys(communityNameData).length !== 0 ? (
                            <div className={`searchbar-content-info-block suggestions ${showDropDown ? 'visible' : ''}`}>

                                <div className="content-inner-wrapper">
                                    {Array.isArray(communityNameData) &&
                                        communityNameData.map((community, index) => (
                                            <div className="content-wrapper-box" key={community?.id}>
                                                <div
                                                    className="main-content-block d-flex justify-content-between border-b-2 border-gray-500 py-1"
                                                    onClick={() => handleSelect(community)}
                                                    style={{
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    <div className="community-name-block">
                                                        {highlightMatch(capitalizeWords(community?.community_name), inputValue)}
                                                    </div>
                                                    <div className="community-city-state">
                                                        <span className="community-city-name">
                                                            {community?.location?.city ? `${community?.location?.city}, ` : ""}
                                                        </span>
                                                        <span className="community-state-name">
                                                            {community?.location?.state}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                </div>
                            </div>) : (
                            <div className={`searchbar-content-info-block suggestions ${showDropDown && inputValue ? 'visible' : ''}`}>
                                {/* <h1>hkjj</h1> */}
                                {Object.keys(communityNameData).length === 0 && inputValue ? (
                                    <div>
                                        {/* <div className="horizontl-line mt-2"></div> */}
                                        <div className="cant-find-community-block">
                                            {!loading && <h6 className="mt-3 mb-3">
                                                Can't find your community?
                                            </h6>}
                                            <div className="input-searchbar-community">
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        gap: "16px",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <div className="input-auto">
                                                        <Autocomplete onLoad={onLoad} onPlaceChanged={onPlaceChanged} options={{ types: ['(cities)'], componentRestrictions: { country: "us" } }}>

                                                            <input
                                                                type="text"
                                                                placeholder="Type City..."
                                                                value={inputValueAuto}
                                                                onChange={(e) => setInputValueAuto(e.target.value)}
                                                                style={{
                                                                    width: "100%",
                                                                    padding: "8px",
                                                                    fontSize: "16px",
                                                                    borderRadius: "20px",
                                                                }}
                                                            />
                                                        </Autocomplete>
                                                    </div>
                                                    {errors.city && (
                                                        <div className="error-text">
                                                            {errors.city}
                                                        </div>
                                                    )}

                                                </div>
                                            </div>
                                            {loading && (
                                                <div className="message_from_admin mt-4 text-center">
                                                    <div className={`message-from-admin mb-2`}>
                                                        Please wait! We are building your community profile now!
                                                    </div>
                                                    <ThreeDot color="#dd483b" size="small" text="" textColor="" />
                                                </div>
                                            )}
                                            <h6 className="mt-3 mb-3">{mes}</h6>
                                        </div>
                                    </div>
                                ) : <></>}
                            </div>
                        )
                    }
                    {!inputValueAuto && (
                        <>
                            {loading && !isGenerated && (
                                <div className="message_from_admin mt-4 text-center">
                                    {/* <div className={`message-from-admin mb-2 ${showMessage ? 'fade-in' : 'fade-out'}`}>
                                              {messages[currentMessageIndex]}
                                            </div> */}
                                    <div className={`message-from-admin mb-2`}>
                                        Please wait! We are building your community profile now!
                                    </div>
                                    <ThreeDot color="#dd483b" size="small" text="" textColor="" />
                                </div>
                            )}
                            {mes && (
                                <div className="message_from_admin mt-4 text-center">
                                    {mes}
                                </div>
                            )}
                        </>
                    )}
                </div>
                <div>
                    <button className="btn-fill-orange orange-filled-btn" onClick={handleSubmit}>
                        {loading ? "Submitting..." : "Submit"}
                    </button>
                </div>
            </div>
            <div className="webcard_oscar_title mt-3 text-center">
                <p className="m-0 p-0">
                    Ask OSCAR: The Smarter Way to Navigate Real Estate
                </p>
            </div>

            <div className="chatbot-wrapper mt-2">
                <div
                    className={`chatbot-button ${isPressed ? 'pressed' : ''}`}
                    onMouseDown={() => setIsPressed(true)}
                    onMouseUp={() => setIsPressed(false)}
                    onMouseLeave={() => setIsPressed(false)}
                >
                    {/* Chat icon */}
                    <div
                        className="owl-logo-lower-blk text-center"
                        onClick={() => {
                            setChatbotActive(!chatbotActive)
                            setDefaultQuestion(true)
                        }}
                    >
                        <div>
                            <a href="#">
                                <img
                                    src={community_icon}
                                    alt="owl_logo"
                                    width="50"
                                    height="50"
                                ></img>
                            </a>
                        </div>
                    </div>

                    {/* Ripple effect */}
                    <div className="ripple-container">
                        <div className="ripple-circle delay-0"></div>
                        <div className="ripple-circle delay-400"></div>
                        <div className="ripple-circle delay-800"></div>
                    </div>
                </div>

                {chatbotActive && (
                    <Chatbot
                        setChatBotActive={setChatbotActive}
                        DefaultQuestion={DefaultQuestion}
                        setDefaultQuestion={setDefaultQuestion}
                    />
                )}
            </div>
        </div>
    )
}

export default CommunitySearch